export enum BusinessEntityType {
  MoralPerson,
  PhysicalPerson,
  Escrow,
  PublicSector,
}

export const businessEntityTypeValues: { [id: number]: string } = {
  0: 'Persona Moral',
  1: 'Persona Física',
  2: 'Fideicomiso',
  3: 'Sector Público',
};

export namespace BusinessEntityType {
  export function values() {
    return Object.keys(BusinessEntityType)
      .filter((type) => isNaN(<any>type) && type !== 'values')
      .map((key, index) => {
        return { key: businessEntityTypeValues[index], value: index };
      });
  }
}
